import React from 'react';
import { connect } from 'react-redux';
import * as shopActions  from '../../../../../../actions/shopActions';
import * as productLocationActions  from '../../../../../../actions/productMainEdit/productLocationActions';
import axios from './../../../../../../constants/axios';
import alert from 'alertify.js';


import ShopList from './ShopList';

class ProductMainEditLocation extends React.Component {
   componentDidMount() {
      const { productId } = this.props.params;
      this.props.dispatch(shopActions.loadShops());
      this.props.dispatch(productLocationActions.loadProductLocationsById(productId));
   }

   addCategory = (shopId, categoryId) => {
      const { productId } = this.props.params;
      axios.post(`/items/productMain/addProductLocationCategory/${productId}`, {
         shop_id: shopId,
         category_id: categoryId
      })
         .then((res) => {
            if (res.status === 201) {
               alert.success('Successfully added.');
               this.props.dispatch(productLocationActions.loadProductLocationsById(productId));
            } else {
               alert.error('Something unexpected. Call Rasel.');
            }
         })
         .catch((err) => {
            if (err.response.status === 422) {
               alert.error(err.response.data);
            } else {
               alert.error('Something Horrible. Call Rasel.');
            }
         });
   };


   addSubCategory = (shopId, categoryId, subCategoryId) => {
      const { productId } = this.props.params;
      axios.post(`/items/productMain/addProductLocationSubCategory/${productId}`, {
         shop_id: shopId,
         category_id: categoryId,
         sub_category_id: subCategoryId
      })
         .then((res) => {
            if (res.status === 201) {
               alert.success('Successfully added.');
               this.props.dispatch(productLocationActions.loadProductLocationsById(productId));
            } else {
               alert.error('Something unexpected. Call Rasel.');
            }
         })
         .catch((err) => {
            if (err.response.status === 422) {
               alert.error(err.response.data);
            } else {
               alert.error('Something Horrible. Call Rasel.');
            }
         });
   };

   removeCategory = (categoryId) => {
      const { productId } = this.props.params;
      axios.post(`/items/productMain/removeProductLocationCategory/${productId}`, {
         category_id: categoryId
      })
         .then((res) => {
            if (res.status === 204) {
               alert.success('Successfully unlinked.');
               this.props.dispatch(productLocationActions.loadProductLocationsById(productId));
            } else {
               alert.error('Something unexpected. Call Rasel.');
            }
         })
         .catch((err) => {
            if (err.response.status === 422) {
               alert.error(err.response.data);
            } else {
               alert.error('Something Horrible. Call Rasel.');
            }
         });
   };

   removeSubCategory = (subCategory) => {
      const { productId } = this.props.params;
      axios.post(`/items/productMain/removeProductLocationSubCategory/${productId}`, {
         sub_category_id: subCategory
      })
         .then((res) => {
            if (res.status === 204) {
               alert.success('Successfully unlinked.');
               this.props.dispatch(productLocationActions.loadProductLocationsById(productId));
            } else {
               alert.error('Something unexpected. Call Rasel.');
            }
         })
         .catch((err) => {
            if (err.response.status === 422) {
               alert.error(err.response.data);
            } else {
               alert.error('Something Horrible. Call Rasel.');
            }
         });
   };

   render() {
      const { productLocations } = this.props;
      return (
         <div className="ProductMainEditLocation" >
            <h4>Main Product Location</h4>
            <div className="row" >
               <div className="col-md-6" >
                  <ul>
                     {productLocations.map((shop) => (
                        <li key={shop.id} >
                           {shop.name}
                           <ul>
                              {shop.categories.map((category) => (
                                 <li key={category.id} >
                                    {
                                       !category.subCategories ?
                                          <span className="remove-button"
                                                onClick={() => this.removeCategory(category.id)} >remove</span>
                                          :
                                          null
                                    }

                                    {category.name}
                                    {
                                       category.subCategories ?
                                          <ul>
                                             {category.subCategories.map((subCat) => (
                                                <li key={subCat.id} >
                                                   <span className="remove-button"
                                                         onClick={() => this.removeSubCategory(subCat.id)} >remove</span>
                                                   {subCat.name}
                                                </li>
                                             ))}
                                          </ul>
                                          :
                                          null
                                    }
                                 </li>
                              ))}
                           </ul>
                        </li>
                     ))}
                  </ul>
               </div>
               <div className="col-md-6" >
                  <ShopList shops={this.props.shops} addCategory={this.addCategory}
                            addSubCategory={this.addSubCategory} />
               </div>
            </div>
         </div>
      );
   }
}


ProductMainEditLocation.propTypes = {
   params: React.PropTypes.object,
   dispatch: React.PropTypes.func,
   shops: React.PropTypes.array,
   productLocations: React.PropTypes.array,
};

function mapStateToProps(state) {
   return {
      shops: state.shops,
      productLocations: state.productLocations
   };
}
export default connect(mapStateToProps)(ProductMainEditLocation);



/** WEBPACK FOOTER **
 ** ./src/components/ItemManagement/Product/ProductMain/ProductMainEdit/ProductMainLocation/ProductMainEditLocation.js
 **/